// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uk5HMaQtwr3LTSIyfSh-A {\n  display: table;\n}\n\n.uk5HMaQtwr3LTSIyfSh-A .form-group {\n  display: table-row;\n}\n\n.uk5HMaQtwr3LTSIyfSh-A .form-group > * {\n  display: table-cell;\n}\n\n.uk5HMaQtwr3LTSIyfSh-A .form-group .control-label {\n  font-weight: bold;\n}\n\n.uk5HMaQtwr3LTSIyfSh-A .form-group > div > div {\n  padding: 0 13px;\n}\n\n._3YtCOFeUwXKNQczHfwZ6zU {\n  margin-top: 0;\n  text-align: center;\n}\n\n._18Pjms5jw37LyNeM_s66jt.table-responsive {\n  border: none;\n}", ""]);
// Exports
exports.locals = {
	"formTable": "uk5HMaQtwr3LTSIyfSh-A",
	"header": "_3YtCOFeUwXKNQczHfwZ6zU",
	"tableResponsive": "_18Pjms5jw37LyNeM_s66jt"
};
module.exports = exports;
